import {useLocation} from 'hooks'
import qs from 'qs'

export default function useQueryParams(options={ignoreQueryPrefix: true}) {
  const {search} = useLocation()
  return qs.parse(search, options)
}